<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V8fNfp/tc-custom/9780226131535.jpg?1731804952310" alt="This image is the cover for the book Good Project"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Project
      </h1>
      <p class="bookDescription body article font2">
        <p>NGOs set out to save lives, relieve suffering, and service basic human needs. They are committed to serving people across national borders and without regard to race, ethnicity, gender, or religion, and they offer crucial help during earthquakes, tsunamis, wars, and pandemics. But with so many ailing areas in need of assistance, how do these organizations decide where to go—and who gets the aid?<br/><br/> In<i> The Good Project</i>, Monika Krause dives into the intricacies of the decision-making process at NGOs and uncovers a basic truth: It may be the case that relief agencies try to help people but, in practical terms, the main focus of their work is to produce projects. Agencies sell projects to key institutional donors, and in the process the project and its beneficiaries become commodities. In an effort to guarantee a successful project, organizations are incentivized to help those who are easy to help, while those who are hardest to help often receive no assistance at all. The poorest of the world are made to compete against each other to become projects—and in exchange they offer legitimacy to aid agencies and donor governments. Sure to be controversial, <i>The Good Project</i> offers a provocative new perspective on how NGOs succeed and fail on a local and global level.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Monika Krause
      </h2>
      
      <p class="authorDescription body article"><B>Monika Krause</B> teaches sociology at Goldsmiths, University of London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1710824b